<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Player Tournaments Registration - {{username}}<span class="badge">{{totalRecords }}</span></h4>
            </div>
            <div class="rightDiv">
                <!-- <button class="exportBTn">
                    <span>
                        <img src="../../../assets/images/backend-image/header/exportIcon.svg" alt="">
                    </span> Export
                </button> -->
            </div>
        </div>
        <div class="mainDivBody">
            <div class="maintableDiv">
                <div class="tableParanet">
                    <p-table id="vdtnetable10" #dt [value]="matchList" [paginator]="true" [rows]="10"
                        [rowsPerPageOptions]="paginationOption" [lazy]="true" scrollHeight="auto"
                        scrollDirection="horizontal" [totalRecords]="totalRecords" [loading]="loading"
                        [scrollable]="true" cellpadding="0" class="transaction-history"
                        styleClass="p-datatable-gridlines p-datatable-striped"
                        (onLazyLoad)="getMyTournamentList($event)" aria-describedby="vdtnetable10_info">
                        <ng-template pTemplate="header">
                            <tr>

                                <th pSortableColumn="tournamentName" class="nameTD">
                                    <div>Name
                                        <p-sortIcon field="tournamentName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="matchName" class="categoryTd" rowspan="1" colspan="1"
                                    style="">
                                    <div>Categories
                                        <p-sortIcon field="matchName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="agegroupName" class="agegroupNameTd" rowspan="1" colspan="1"
                                    style="">
                                    <div>Age Group
                                        <p-sortIcon field="agegroupName"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="entryFee" class="entryFeeTD" rowspan="1" colspan="1"
                                    style="">
                                    <div>Entry Fees
                                        <p-sortIcon field="entryFee"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="lastdateofwithdraw" class="lastdateofwithdrawTD" rowspan="1"
                                    colspan="1" style="">
                                    <div> Withdrawal Date
                                        <p-sortIcon field="lastdateofwithdraw"></p-sortIcon>
                                    </div>
                                </th>
                                <th pSortableColumn="tournamentEndDate" class="tournamentEndDateTD" rowspan="1" colspan="1"
                                    style="">
                                    <div>End Date
                                        <p-sortIcon field="tournamentEndDate"></p-sortIcon>
                                    </div>
                                </th>
                                <!-- <th pSortableColumn="tournamentStatus" class="sorting_disabled" rowspan="1"
                                        colspan="1" style="">
                                        <div>Status
                                            <p-sortIcon field="tournamentStatus"></p-sortIcon>
                                        </div>
                                    </th> -->
                                <th class="actionTD p-frozen-column" rowspan="1" colspan="1">
                                     Action 
                                </th>

                            </tr>
                            <tr>
                                <th class="nameTD">
                                    <input pInputText type="text" 
                                        (keyup.enter)="dt.filter($event.target.value, 'tournamentName', 'contains')"
                                        style="width:100%"
                                        [value]="dt.filters['tournamentName'] ? dt.filters['tournamentName'].value : ''"
                                        [(ngModel)]="filterByName"/>
                                </th>
                                <th class="categoryTd">
                                    <input pInputText type="text" 
                                        (keyup.enter)="dt.filter($event.target.value, 'matchName', 'contains')"
                                        style="width:100%"
                                        [value]="dt.filters['matchName'] ? dt.filters['matchName'].value : ''"
                                        [(ngModel)]="filterByCategory"/>
                                </th>
                                <th class="agegroupNameTd">
                                    <input pInputText type="text" 
                                        (keyup.enter)="dt.filter($event.target.value, 'agegroupName', 'contains')"
                                        style="width:100%"
                                        [value]="dt.filters['agegroupName'] ? dt.filters['agegroupName'].value : ''"
                                        [(ngModel)]="filterByAgeGroup"/>
                                </th>
                                <th class="entryFeeTD">
                                    <input pInputText type="text" 
                                        (keyup.enter)="dt.filter($event.target.value, 'entryFee', 'contains')"
                                        style="width:100%"
                                        [value]="dt.filters['entryFee'] ? dt.filters['entryFee'].value : ''"
                                        [(ngModel)]="filterByEntryFee"/>
                                </th>
                                <th class="lastdateofwithdrawTD">
                                    <p-calendar 
                                        appendTo="body"
                                        (onSelect)="onWithdrawalDateSelect($event)"
                                        [(ngModel)]="filterByWithdrawalDate"
                                        class="p-calendar w-100"
                                        dateFormat="dd/mm/yy"
                                        [showIcon]="true">
                                    </p-calendar>
                                </th>
                                <th class="tournamentEndDateTD">
                                    <p-calendar 
                                        appendTo="body"
                                        (onSelect)="onEndDateSelect($event)"
                                        [(ngModel)]="filterByEndDate"
                                        class="p-calendar w-100"
                                        dateFormat="dd/mm/yy"
                                        [showIcon]="true">
                                    </p-calendar>
                                </th>
                                <th class="actionTD p-frozen-column"></th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-matchList>
                            <tr>
                                <td class="nameTD">
                                    <span class="rin-type-label state-finished" pTooltip=" {{matchList.tournamentName}}"
                                        tooltipPosition="top">
                                        {{matchList.tournamentName}}
                                    </span>
                                </td>
                                <td class="categoryTd"><span class="rin-type-label state-finished">
                                        {{matchList.matchName}}
                                    </span></td>
                                <td class="agegroupNameTd"><span class="rin-type-label state-finished">
                                        {{matchList.ageGroupName}}
                                    </span></td>
                                <td class="entryFeeTD"><span class="rin-type-label state-finished">
                                        {{matchList.entryFee}}
                                    </span></td>
                                <td class="lastdateofwithdrawTD"><span class="rin-type-label state-finished">
                                        {{matchList.lastdateofwithdraw| date : 'dd/MM/yyyy'}}
                                    </span></td>
                                <td class="tournamentEndDate"><span class="rin-type-label state-finished">
                                        {{matchList.tournamentEndDate | date : 'dd/MM/yyyy'}}
                                    </span></td>
                                <!-- <td><span class="rin-type-label state-finished">
                                            {{matchList.tournamentStatus}}
                                        </span></td> -->
                                <td class="actionTD p-frozen-column">
                                    <div class="status-buttons" *ngIf="matchList.showWithdraw == true">
                                        <button class="btn btn-success"
                                            (click)="withdrawModal(matchList.id,matchList.tournamentName,matchList.matchName,matchList.ageGroupName)"
                                            id="withdrawal-btn"><span class="icon"><img src="../../../../assets/images/backend-image/header/widraw.svg" alt=""></span>
                                            Withdraw</button>
                                    </div>
                                    <div class="disableBtn status-buttons" *ngIf="matchList.showWithdraw == false"
                                        pTooltip="Withdrawal Date Expired" tooltipPosition="top">
                                        <button class="btn btn-success"
                                            (click)="withdrawModal(matchList.id,matchList.tournamentName,matchList.matchName,matchList.ageGroupName)"
                                            id="withdrawal-btn" disabled><span class="icon"><img src="../../../../assets/images/backend-image/header/widraw.svg" alt=""></span>
                                            Withdraw</button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>

    </div>
</div>
<p-dialog id="Entertournamentthank" [(visible)]="thankwithdrawinfo"
  [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '400px' }" [modal]="true"
  [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="modal-header">
    <h5 class="modal-title" id="EntertournamentLabel">Tournament Withdraw </h5>
    <!-- <div class="headings col-md-12">
      <h6>{{tournamentname}}</h6>
    </div> -->
  </ng-template>
  <!---test-->
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <div class="headings col-md-12">
          <h6>{{tname}}</h6>
          <p class="note">You have successfully Withdraw</p>
        </div>
        <div class="countdown-container">
          <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
          <div class="countdown-text">{{ countdown }}</div>
          <br>

        </div>
        <div class="timer-alert">
          Please wait 10 seconds.
        </div>
        <p class="note text-left mainNotes">
          <span> <img src="../../../assets/images/tournament/information-orange.svg" alt=""> </span>
          <span>Your payment will be automatically debited from Wallet.</span>

        </p>
      </div>
    </div>
  </div>
</p-dialog>

<!-- <p-dialog id="Entertournamentthank" [(visible)]="thankwithdrawinfo"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '38rem' }" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Withdraw</h5>
                <div class="headings col-md-12">

                    <h6>{{tname}}</h6>


                    <div class="countdown-container">
                        <div class="countdown-circle" [style.animation-duration.seconds]="10"></div>
                        <div class="countdown-text">{{ countdown }}</div>
                        <br>

                    </div>
                    <div class="timer-alert">
                        Please wait
                    </div>
                    <p class="note">We are processing your request for a refund in the tournament category. Once the
                        refund
                        process is successfully completed, please check wallet Balance.</p>

                </div>

            </div>
        </div>
    </div>
</p-dialog> -->


<p-dialog id="admin-widthdraw-confitmation" [(visible)]="WithdrawcnfModal"
    [breakpoints]="{ '960px': '541px' , '768px': 'calc(100% - 60px)'}" [style]="{ width: '541px' }" [modal]="true" [draggable]="false"
    [resizable]="false">
    <!---test-->

    <div class="modal-dialog w-100 modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important; width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Withdraw Confirmation
                </h5>
            </div>
            <div class="modal-body">

                <p>
                    Are you sure you want to withdraw from the tournament? Please note that this action cannot be
                    undone, and your participation in the tournament will be canceled.
                </p>


                <div class="add-even col-md-12">
                    <!-- <div class="event-number">Add Partner</div> -->

                    <div class="event-details-list">
                        <div class="list-div-selection">
                            <div class="event-details">
                                <div class="title">{{tname}}</div>
                                <div class="Event-cate">
                                    <ul>
                                        <li>
                                            <span class="small-heading">{{mtn}}</span>
                                            <p>{{agn}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div> 
                </div>
                <p>
                        After the withdrawal, the entry fee amount will be credited back to your TPL wallet. in cash
                        within 4
                        days.
                    </p>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-primary mx-auto " (click)="thankyouwithdraw()">Proceed with the
                    withdrawal</button>
            </div>
        </div>


    </div>

</p-dialog>
<p-dialog id="Entertournamentthankadmin" [(visible)]="thankwithdraw"
    [breakpoints]="{ '960px': '75vw', '768px': '100%' }" [style]="{ width: '500px' }" [modal]="true" [draggable]="false"
    [resizable]="false">
    <!---test-->

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="EntertournamentLabel">Tournament Withdraw
                </h5>
                <div class="headings col-md-12">
                    <h6>Davis Cup Qualifiers
                    </h6>
                    <p class="note">
                        Your Tournament withdrawals have been successfully processed.


                    </p>
                </div>

            </div>

        </div>


    </div>

</p-dialog>